import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ collectAccountNumber: string }>;

export const DispatchSetAccountNumber: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/SetAccountNumber",
        collectAccountNumber: props.parameter.collectAccountNumber,
    });
};

export const chain = [DispatchSetAccountNumber];

const setAccountNumber = createHandlerChainRunner(chain, "SetAccountNumber");
export default setAccountNumber;
